import { CONFIRMATION_DIALOG_ACTION_TYPE } from 'store/global/actions';

const initialState = {
  isOpen: false,
  message: '',
  description: '',
  onAccept: null,
  customDialogProps: null,
};

const dialogReducer = function (state = initialState, { type, payload }) {
  switch (type) {
    case CONFIRMATION_DIALOG_ACTION_TYPE.OPEN_DIALOG: {
      return {
        ...state,
        ...payload,
        isOpen: true,
      };
    }

    case CONFIRMATION_DIALOG_ACTION_TYPE.CLOSE_DIALOG: {
      return initialState;
    }

    default: {
      return state;
    }
  }
};

export default dialogReducer;
